import styled from 'styled-components';

export const TAB_LABEL = styled.span`
  font-size: 14px;
  font-weight: 600;
  line-height: calc(20 / 14);
`;
